import React, { useContext } from 'react'
import { bool, oneOfType, shape, string } from 'prop-types'
import * as Styled from './FactsBox.styles'
import { Container, Link } from 'components/atoms'
import { TextContext } from 'hocs/TextContextProvider/TextContextProvider'
import { useMobileSwitch } from 'hooks'
import DOMPurify from 'dompurify'

const FactsBox = ({ title, text, link, ...rest }) => {
  const textContext = useContext(TextContext)
  const isMobile = useMobileSwitch()

  const getFacts = () => (
    <>
      <p
        className='text'
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(text) }}
      />
      {link && !isMobile && (
        <Link
          isNativeLink={ true }
          href={ link.url }
          title={ link.title }
          target='_blank'
          rel='noopener noreferrer'
          iconClass={ 'arrow-icon icon-f-arrow-right-circle icon-green' }
        />
      )}
    </>
  )

  const getFactsTitle = () => <h3 className='title'>{title}</h3>

  return (
    <Styled.FactsBox>
      <Container
        className='container-content facts-container'
        isFlat={ true }
        { ...rest }>
        <p className='component-title'>{textContext['factBox.title']}</p>
        {link && isMobile ? (
          <a
            href={ link.url }
            title={ link.title }
            target='_blank'
            rel='noopener noreferrer'>
            {getFactsTitle()}
          </a>
        ) : (
          getFactsTitle()
        )}
        {link ? <div className='content'>{getFacts()}</div> : getFacts()}
      </Container>
    </Styled.FactsBox>
  )
}

FactsBox.defaultProps = {
  link: false,
}

FactsBox.propTypes = {
  title: string.isRequired,
  text: string.isRequired,
  link: oneOfType([
    shape({
      url: string.isRequired,
      title: string.isRequired,
    }),
    bool,
  ]),
}

export default FactsBox
